import _assign from "object-assign";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { fade } from '@material-ui/core/styles';

var createLightPalette = function createLightPalette(_ref) {
  var grey20 = _ref.grey20,
      grey90 = _ref.grey90,
      grey200 = _ref.grey200,
      blue400 = _ref.blue400,
      blue500 = _ref.blue500,
      orange10 = _ref.orange10,
      orange700 = _ref.orange700,
      red10 = _ref.red10,
      white = _ref.white;
  return {
    controlContainer: {
      background: white,
      color: grey200
    },
    activationIndicator: {
      color: grey90,
      "default": {
        hover: blue400,
        focused: blue500
      },
      warning: {
        hover: orange700,
        focused: orange700
      }
    },
    filled: {
      "default": {
        background: grey20
      },
      error: {
        background: red10
      },
      warning: {
        background: orange10
      }
    },
    helperText: {
      color: grey200
    },
    popoutElevatedEffect: {
      boxShadow: [0, 0, 0, 1, blue500]
    }
  };
};

var createDarkPalette = function createDarkPalette(_ref2) {
  var grey800 = _ref2.grey800,
      grey900 = _ref2.grey900,
      grey70 = _ref2.grey70,
      grey100 = _ref2.grey100,
      blue300 = _ref2.blue300,
      blue400 = _ref2.blue400,
      orange500 = _ref2.orange500,
      orange10 = _ref2.orange10,
      red10 = _ref2.red10;
  return {
    controlContainer: {
      background: grey800,
      color: grey70
    },
    activationIndicator: {
      color: grey100,
      "default": {
        hover: blue300,
        focused: blue400
      }
    },
    warning: {
      hover: orange500,
      focused: orange500
    },
    filled: {
      "default": {
        background: grey900
      },
      error: {
        background: red10
      },
      warning: {
        background: orange10
      }
    },
    helperText: {
      color: grey70
    },
    popoutElevatedEffect: {
      boxShadow: [0, 0, 0, 1, blue300]
    }
  };
};

var helperText = {
  touch: {
    marginTop: 8,
    transform: 'translate(0, -3px)'
  },
  low: {
    marginTop: 4,
    transform: 'translate(0, 1px)'
  },
  medium: {
    marginTop: 2,
    transform: 'translate(0, 2px)'
  },
  high: {
    marginTop: 2
  }
};
var fullWidthHelperTextMargin = {
  touch: 5,
  low: 5,
  medium: 3,
  high: 3
};
var labelLeftMarginTranslateY = {
  touch: 16,
  low: 12,
  medium: 8,
  high: 4
};
var labelTopMarginBottom = {
  touch: 8,
  low: 4,
  medium: 2,
  high: 2
};
var captionFontSizeIndices = {
  touch: 50,
  low: 40,
  medium: 40,
  high: 30
};
export var style = function style(_ref3) {
  var toolkit = _ref3.toolkit,
      zIndex = _ref3.zIndex;

  var getDisabled = toolkit.disabled.getDisabled,
      getElevation = toolkit.elevation.getElevation,
      getFocusable = toolkit.focusable.getFocusable,
      _toolkit$palette = toolkit.palette,
      type = _toolkit$palette.type,
      restPalette = _objectWithoutProperties(_toolkit$palette, ["type"]),
      getSize = toolkit.size.getSize,
      _toolkit$statusNext = toolkit.statusNext,
      getStatus = _toolkit$statusNext.getStatus,
      statusStates = _toolkit$statusNext.statusStates,
      spacing = toolkit.spacing,
      typography = toolkit.typography;

  var palette = type === 'dark' ? createDarkPalette(restPalette) : createLightPalette(restPalette);
  var disabledStyle = getDisabled();
  var graphicalDisabled = getDisabled('graphical');

  var createValidationStateStyle = function createValidationStateStyle(state) {
    var _getStatus = getStatus(state),
        color = _getStatus.status;

    var activationIndicatorPalette = palette.activationIndicator[state];
    var filledPalette = palette.filled[state];
    var disabledColor = fade(color, graphicalDisabled.opacity);
    return {
      '&$root:not($disabled)': {
        '&:hover $activationIndicator': {
          borderColor: activationIndicatorPalette && activationIndicatorPalette.hover || color
        }
      },
      '& $activationIndicator ': {
        borderColor: color
      },
      '& $activationIndicatorIcon': {
        fill: color
      },
      '& $focused': {
        outlineColor: color
      },
      '&$filledVariant': {
        '& $controlAreaBackground': {
          background: filledPalette.background
        },
        '&$disabled': {
          '& $controlAreaBackground': {
            background: disabledColor
          }
        }
      },
      '&$disabled': {
        '& $activationIndicator ': {
          borderColor: disabledColor
        },
        '& $activationIndicatorIcon': {
          fill: disabledColor
        }
      },
      '& $popoutElevatedEffect': {
        boxShadow: [[0, 0, 0, 1, color]].concat(_toConsumableArray(getElevation(4, 'blue').boxShadow))
      }
    };
  };

  var createDensityStyle = function createDensityStyle(density) {
    var fontSize = typography.size[captionFontSizeIndices[density]];

    var captionTypography = _assign({
      letterSpacing: 0,
      lineHeight: typography.lineHeight,
      fontSize: fontSize,
      minHeight: typography.getMinHeight(fontSize)
    }, typography.getFace());

    var spacingMixin = spacing[density].spacing;

    var _getSize = getSize({
      density: density
    }),
        minHeight = _getSize.height;

    return {
      '& $helperText': _assign({}, captionTypography, {
        paddingLeft: spacingMixin(1),
        paddingRight: spacingMixin(1),
        color: palette.helperText.color
      }),
      '&:not($fullWidth) $helperText': _assign({}, helperText[density]),
      '&:not($labelLeft) $labelRoot': {
        marginBottom: labelTopMarginBottom[density]
      },
      '&$labelLeft $labelRoot': {
        paddingRight: spacingMixin(0.75),
        transform: "translate(0px, ".concat(labelLeftMarginTranslateY[density], "px)")
      },
      '&$hasHelperText$labelLeft $labelRoot': {},
      '&$fullWidth $controlArea': {
        minHeight: 0
      },
      '&$fullWidth $helperText': {
        marginTop: fullWidthHelperTextMargin[density]
      },
      '& $statusIndicatorMessage': {
        marginBottom: spacingMixin(0.5)
      },
      '& $controlArea': {
        minHeight: minHeight
      }
    };
  };

  return {
    root: {
      boxSizing: 'border-box',
      justifyContent: 'flex-start',
      '&:hover $activationIndicator': {
        borderColor: palette.activationIndicator["default"].hover
      }
    },
    controlContainer: {
      display: 'flex',
      position: 'relative',
      justifyContent: 'center',
      // for IE 11
      minHeight: 1
    },
    controlAreaWrapper: {
      position: 'relative',
      width: '100%',
      // for IE 11
      minHeight: 1
    },
    controlArea: {
      position: 'relative',
      width: '100%',
      lineHeight: 1
    },
    controlAreaBackground: {
      height: '100%',
      left: 0,
      position: 'absolute',
      top: 0,
      width: '100%',
      boxSizing: 'border-box'
    },
    controlAreaPopout: {
      zIndex: zIndex.tooltip - 1
    },
    labelRoot: {},
    labelLeft: {
      '& $labelRoot': {
        display: 'inline-flex',
        flexGrow: 1,
        flexShrink: 0
      }
    },
    disabled: {
      cursor: disabledStyle.cursor,
      '& $activationIndicator': {
        borderColor: fade(palette.activationIndicator.color, graphicalDisabled.opacity)
      },
      '&:hover $activationIndicator': {
        borderColor: fade(palette.activationIndicator.color, graphicalDisabled.opacity)
      },
      '& $helperText': {
        opacity: disabledStyle.opacity
      }
    },
    labelTop: {
      flexDirection: 'column'
    },
    focused: _assign({}, getFocusable(), {
      outlineOffset: 0,
      '& $activationIndicator': {
        borderBottomWidth: 2,
        borderColor: palette.activationIndicator["default"].focused
      }
    }),
    popoutOffsetFocused: {
      // This is needed when popout adds a border like box shadow and we don't want part of the
      // focus ring to be covered up by it
      outlineOffset: 1
    },
    popoutElevatedEffect: {
      boxShadow: [palette.popoutElevatedEffect.boxShadow].concat(_toConsumableArray(getElevation(4, 'blue').boxShadow))
    },
    lowEmphasisFocus: {
      outline: 'none'
    },
    helperText: {
      fontStyle: 'italic'
    },
    hasHelperText: {},
    fullWidth: {},
    activationIndicator: {
      borderBottom: '1px',
      borderBottomStyle: 'solid',
      position: 'absolute',
      height: 'auto',
      width: '100%',
      bottom: 0,
      left: 0,
      borderColor: palette.activationIndicator.color,
      color: palette.activationIndicator.color
    },
    activationIndicatorIcon: {
      position: 'absolute',
      bottom: 3,
      right: 2
    },
    readOnly: {
      '& $activationIndicator': {
        opacity: 0.2
      },
      '&:hover $activationIndicator': {
        borderColor: 'inherit'
      }
    },
    error: createValidationStateStyle(statusStates.error),
    warning: createValidationStateStyle(statusStates.warning),
    touchDensity: createDensityStyle('touch'),
    lowDensity: createDensityStyle('low'),
    mediumDensity: createDensityStyle('medium'),
    highDensity: createDensityStyle('high'),
    themeVariant: {
      '& $controlAreaBackground': {
        background: palette.controlContainer.background
      },
      '&$readOnly': {
        '& $controlAreaBackground': {
          background: 'transparent'
        }
      },
      '&$disabled': {
        '& $controlAreaBackground': {
          background: fade(palette.controlContainer.background, graphicalDisabled.opacity)
        }
      }
    },
    statusIndicatorMessage: {
      margin: 0
    },
    statusIndicatorContainer: {
      padding: 0,
      margin: 0,
      '& $statusIndicatorMessage:last-child': {
        marginBottom: 0
      }
    },
    filledVariant: {
      '& $controlAreaBackground': {
        background: palette.filled["default"].background
      },
      '&$disabled': {
        '& $controlAreaBackground': {
          background: fade(palette.filled["default"].background, graphicalDisabled.opacity)
        }
      }
    },
    transparentVariant: {
      '& $controlAreaBackground': {
        background: 'transparent'
      }
    }
  };
};